import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { PageHeading } from '../../layout/PageHeading';
import { usePageTitle } from '../../layout/usePageTitle';

export function ForbiddenPage() {
  const { t } = useTranslation();
  usePageTitle([t('errors.forbidden.title')]);
  return (
    <div className="govuk-grid-row">
      <div className="govuk-grid-column-two-thirds">
        <PageHeading>{t('errors.forbidden.title')}</PageHeading>
        <p className="govuk-body">{t('errors.forbidden.body')}</p>
        <p className="govuk-body">
          <Link className="govuk-link" to="/">
            {t('errors.backHome')}
          </Link>
        </p>
      </div>
    </div>
  );
}
